// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text[data-v-3695c504] {\n  text-align: left;\n  margin: auto;\n  width: 240px;\n}\n", ""]);
// Exports
module.exports = exports;
